export const LOGO_URL = "/aawta-logo.png";

export const Logo = ({ className = "h-12", onDark = false }) => (
  <img
    src={LOGO_URL}
    alt="African American Women Trucking Association logo"
    className={className}
    style={onDark ? { filter: "drop-shadow(0 0 0.5px rgba(255,255,255,0.4))" } : undefined}
    data-testid="aawta-logo"
  />
);
